document.addEventListener("DOMContentLoaded", () => {
	const heroBanner = document.querySelectorAll(".hero-banner");
	return; // Animations disabled as per client request
	// matches
	const isDesktop = window.matchMedia("(min-width: 1024px)").matches;

	heroBanner.forEach((banner) => {
		const pictureWrapper = banner.querySelector(".picture-wrapper");
		const textBlock = banner.querySelector(".hero-banner__text-block");
		const heroTitle = textBlock.querySelector("[data-hero-title]");
		const heroSubtitle = textBlock.querySelector("[data-hero-subtitle]");
		const scrollBadge = textBlock.querySelector("[data-scroll-badge]");

		const isDesktop = window.innerWidth >= 1024;
		
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: banner,
				start: () => "top top",
				end: () => "bottom+=100% top",
				pin: true,
				scrub: true,
			},
		});

		// Animate picture
		tl.to(
			pictureWrapper,
			{
				scale: 0.7,
				borderRadius: "24px",
				ease: "expo.inOut",
				duration: 1,
			},
			"="
		);

		if (heroTitle) {
			tl.to(
				heroTitle,
				{
					opacity: 0,
					duration: 1,
					ease: "expo.inOut",
				},
				"<"
			);
		}

		if (heroSubtitle) {
			tl.to(
				heroSubtitle,
				{
					opacity: 0,
					duration: 1,
					ease: "expo.inOut",
				},
				"<"
			);
		}
		if (scrollBadge) {
			tl.to(
				scrollBadge,
				{
					opacity: 0,
					duration: 1,
					ease: "expo.inOut",
				},
				"<"
			);
		}
	
	});
});